const article = {
	slug: "paris-transit-inclusive-design",
	title: "One Panicky Bus Ride in Paris Taught Me About Inclusive Design",
	date: "August 2025",
	updated: null,
	description: "A broken ticketing experience on Paris Bus 63 became a lesson in how digital transformation can exclude users, and a side project built from frustration and empathy.",
	keywords: ["inclusive design", "digital transformation", "side project", "transit"],
	tldr: "Modern systems feel fragile when one small step breaks for someone who does not speak the language. The real challenge is inclusive design, not technical perfection.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, August 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `I said "Shut up and take my money." Paris said "Download deux applications, s'il vous plaît."

One panicky bus ride in Paris taught me a lot about systems, stress, and empathy.

## The system broke

A couple of months ago, I was wandering the streets of City of Lights as a tourist. My French at that time was limited to Bonjour, Omlette Du Fromage, And Prashant. ;).

I wanted to visit the Musée du Louvre (Louvre Museum) to see the Mona Lisa, so I checked Google Maps and ran to catch the Bus 63 which was a few mins away.

Here's what I didn't expect.

There were no physical ticket machines. No staff. No cash option. Just an app... in French.

Actually, two apps: One to buy tickets, another to add money.

No problem, I thought. I have used mobile payments in plenty of cities.

None of my five international cards were accepted. (I learned later that there was a geo fencing problem)

I tried again multiple times. Translated French error messages with ChatGPT. Still nothing.

No helpful locals around. No way to pay in cash. Just me and 30 anxiety-filled minutes of ticketless travel through Paris, hoping I don't get fined.

Shows just how fragile modern systems can feel when one tiny step breaks. The system broke down for someone who didn't speak the language and didn't know the rules.

## Building from frustration

So I started building something last month for fellow English speaking travelers: a small side project that pulls live data from the Paris transit APIs and gives English-speaking travelers one simple, mobile-friendly view of how to navigate the system. And to cut through the confusion, it features a working intelligent AI assistant.

No downloads. No friction. Just clarity when you are feeling lost.

If it helps someone feel less helpless in a foreign city, it's done its job.

Paris sees 50M+ visitors, and a lot of them hit the same payment barriers I did.

The validation for this page came from an unexpected source at Metropolitan Transportation Authority NYC. They said this would be a very useful tool for travelers not just in Paris, but in a lot of touristy cities, NYC included.

I have reached out to RATP group and Ile-De-France Mobilités for their feedback and backing for reliable API accesses.

## The real challenge

This experience highlighted how digital transformation can inadvertently exclude users.

My key takeaway for our industry, which serves diverse global users, is this: The real challenge is designing inclusive systems that work across diverse user contexts rather than a technical challenge.

Sometimes, side projects are born from frustration. Sometimes, they are born from empathy. This one? A bit of both.

Merci.`,
};

export default article;
